<template>
  <a-modal v-model="modal" title="请编辑领料单" width="1000px" :maskClosable="false">
    <div class="pick-material-modal-css">
      <div class="example" v-if="loading">
        <a-spin />
      </div>
      <div v-for="(item, index) in dataList" :key="item.id + index" class="pick-material" v-show="!loading">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="6">{{ item.title }}领料单</td>
          </tr>
          <tr>
            <td class="tac table-title">领料人</td>
            <td class="tac">
              <a-input v-model="item.lxr" placeholder="请输入" allowClear />
            </td>
            <td class="tac table-title">生产序号</td>
            <td class="tac" colspan="3">
              <a-input v-model="item.scxh" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">领料部门</td>
            <td class="tac">
              <a-input v-model="item.llbm" placeholder="请输入" allowClear />
            </td>
            <td class="tac table-title">计划单号</td>
            <td class="tac" colspan="3">{{ item.orderNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">工单号</td>
            <td class="tac">{{ item.wipEntityName }}</td>
            <td class="tac table-title">成品物料名称</td>
            <td class="tac" colspan="3">{{ item.itemName }}</td>
          </tr>
          <tr>
            <td class="tac table-title">单据编号</td>
            <td class="tac">{{ item.dispatchNumber }}</td>
            <td class="tac table-title">工单总数量</td>
            <td class="tac" colspan="3">{{ item.planQuantity }}</td>
          </tr>
          <tr>
            <td class="tac table-title">成品规格描述</td>
            <td class="tac" colspan="5">{{ item.specification }}</td>
          </tr>
          <tr>
            <td class="tac table-title">物料编码</td>
            <td class="tac table-title">物料名称</td>
            <td class="tac table-title">派工数量（套）</td>
            <td class="tac table-title">定量（米/平方英寸）</td>
            <td class="tac table-title">合计</td>
            <td class="tac table-title">领料数量</td>
          </tr>
          <tr v-if="item.materialItemList.length===0">
            <td class="tac" colspan="6">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.materialItemList" :key="material.itemCode + materialIndex">
            <td class="tac" width="15%">{{ material.itemCode }}</td>
            <td class="tac" width="34%">{{ material.itemName }}</td>
            <td class="tac" width="15%">
              <a-input-number
                style="width: 100%;"
                v-model="material.planQuantity"
                :min="0"
                :max="Number(item.planQuantity || 0)"
                placeholder="请输入"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                @blur="onBlurPgsl(material)" />
            </td>
            <td class="tac" width="11%">{{ material.quantityPerAssembly }}</td>
            <td class="tac" width="11%">{{ material.hj }}</td>
            <td class="tac" width="14%">
              <a-input-number
                style="width: 100%;"
                v-model="material.llsl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="5">
              <a-input type="textarea" :autoSize="{minRows:2}" v-model="item.remark" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">
              <a-input v-model="item.tbl" placeholder="请输入" allowClear />
            </td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac" colspan="3">
              <a-input v-model="item.zppc" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">实际用量</td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="item.sjyl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
            <td class="tac table-title">仿皮批次</td>
            <td class="tac" colspan="3">
              <a-input v-model="item.fppc" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">计划生产时间</td>
            <td class="tac">
              <a-date-picker
                v-model="item.planProductDate"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </td>
            <td class="tac table-title">工单交期</td>
            <td class="tac">{{ item.assessmentDeliveryDate }}</td>
            <td class="tac table-title">完工时间</td>
            <td class="tac">
              <a-date-picker
                v-model="item.endTime"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="6">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
        <div class="text-line" v-if="dataList.length>1">
          <span>第{{ index + 1 }}单&nbsp;&nbsp;共{{ dataList.length }}单</span>
        </div>

      </div>
      <div class="display-none">
        <PrintPickMaterial ref="printPickMaterialRef" id="printPickMaterialId" />
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;">取消</a-button>
        <a-button type="primary" @click="checkPrint" :loading="btnLoading||loading">确认打印</a-button>
        <a-button ref="printPickMaterialBtn" v-show="false" v-print="'#printPickMaterialId'">打印领料单</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import PrintPickMaterial from './print-pick-material'
import moment from 'moment';
import {
  apiMesDispatchGetMaterialPrintList,
  apiMesDiscreteJobsGetMaterialPrintList,
  apiMesUpdateMaterialRequisitionPrintTimes,
  apiMesUpdateMesRequirementDispatchQuantity,
  apiMesGenerateDispatchNumber, apiMesCheckDispatchQuantity
} from '@/api/mes/workOrderManage/workOrderSent'
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'PickMaterialModal',
  components: {
    PrintPickMaterial
  },
  data () {
    return {
      dataList: [],
      modal: false,
      loading: false,
      btnLoading: false,
      selectRow: []
    }
  },
  methods: {
    moment,
    // 每行派工数据合计,简单处理精度问题
    onBlurPgsl(data) {
      const total = Number(data.planQuantity || 0) * Number(data.quantityPerAssembly || 0)
      data.hj = Math.round(total * 100) / 100
      this.$forceUpdate()
    },
    show(selectRow, type) {
      this.selectRow = selectRow
      this.getData(type)
      this.modal = true
    },
    // 打印前先检查是否超出计划数量
    checkPrint() {
      const paramList = []
      this.dataList.forEach(item => {
        if(item?.materialItemList?.length > 0) {
          item.materialItemList.forEach(val => {
            paramList.push({ mesRequirementOperationsId: val.mesRequirementOperationsId, quantity: val.planQuantity })
          })
        }
      })
      this.btnLoading = true
      apiMesCheckDispatchQuantity(paramList).then(res => {
        this.btnLoading = false
        if (res?.code === 200) {
          if(res?.data) {
            this.$confirm({
              title: '提示',
              content: `总派工数量已超出计划，确认是否打印?`,
              okText: '确定',
              cancelText: '取消',
              onOk: () => {
                this.onPrintPickMaterial() // 确定打印
              }
            })
          } else {
            this.onPrintPickMaterial() // 确定打印
          }
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 打印
    onPrintPickMaterial() {
      this.btnLoading = true
      // 更新打印次数
      apiMesUpdateMaterialRequisitionPrintTimes(this.selectRow.map(v => v.id)).then(res => {
        if (res?.code === 200) {
          this.updateData() // 更新派工数量
        } else {
          this.$message.error(res?.msg || '更新打印次数接口失败！')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 更新派工数量
    updateData() {
      const paramList = []
      this.dataList.forEach(item => {
       if(item?.materialItemList?.length > 0) {
         item.materialItemList.forEach(val => {
           paramList.push({ mesRequirementOperationsId: val.mesRequirementOperationsId, quantity: val.planQuantity })
         })
       }
      })
      this.btnLoading = true
      apiMesUpdateMesRequirementDispatchQuantity(paramList).then(res => {
        if (res?.code === 200) {
          this.toPrint()
        } else {
          this.$message.error(res?.msg || '更新派工数量接口失败！')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 生成领料单号
    generateDispatchNumber() {
      this.btnLoading = true
      apiMesGenerateDispatchNumber({ number: this.dataList.length }).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          res.data.forEach((val, index) => {
            this.$set(this.dataList[index], 'dispatchNumber', val) // 更新单据编号
          })
        } else {
          this.$message.error(res?.msg || '生成领料单号失败')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 打印领料单
    toPrint() {
      this.$refs.printPickMaterialRef.show(cloneDeep(this.dataList))
      setTimeout(() => {
        this.$refs.printPickMaterialBtn.$el.dispatchEvent(new MouseEvent("click"))
        this.generateDispatchNumber() // 重新生成领料单号
        }, 200)
    },
    // 获取数据
    getData(type) {
      this.dataList = []
      this.loading = true
      const apiRequest = type === 'workOrderDesk' ? apiMesDiscreteJobsGetMaterialPrintList : apiMesDispatchGetMaterialPrintList
      apiRequest(this.selectRow.map(v => v.id)).then(res => {
        if (res.data && res.data.length > 0) {
          this.dataList = res.data
          this.dataList.forEach(item => {
            if(item?.materialItemList?.length > 0) {
              item.materialItemList.forEach(material => {
                this.onBlurPgsl(material)
              })
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pick-material-modal-css{
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding: 0 15px;
  font-size: 15px;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 30px 50px;
  margin: 20px 0;
}
.pick-material{
  margin: 10px auto 20px auto;
}
.display-none {
  display: none
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.text-line {
    text-align: center;
    position: relative;
    margin: 20px 0;
    height: 20px; /* 文本上下间距 */
}

.text-line span {
    font-style: italic;
    background-color: white; /* 与背景颜色相同以覆盖分割线 */
    padding: 0 10px; /* 文本左右间距 */
    position: absolute;
    left: 47%;
    transform: translateX(-50%);
    top: 50%;
    transform: translateY(-50%);
    color: #333; /* 文本颜色 */
}

.text-line::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background-color: #9a9a9a;
}
</style>
